export default function userLogoutReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'LOGOUT_USER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'LOGOUT_USER_ERROR':
            return {...state, ...{error: action.error}};

        case 'LOGOUT_USER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}